import useResponsive from '../../hooks/useResponsive';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const ArticleFolderPageHeader = ({ setOpenAddArticleFolder, hasArticleFolderCreatePermission }) => {

    const { t } = useTranslation();
    const isDesktop = useResponsive('up', 'lg');

    const handleAddArticleFolder = useCallback(() => {
        setOpenAddArticleFolder(true);
    }, [setOpenAddArticleFolder]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("ArticleFolders")}</Typography>
            </Box>
            {isDesktop && hasArticleFolderCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddArticleFolder}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addArticleFolderDialogTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasArticleFolderCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddArticleFolder} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(ArticleFolderPageHeader);